import { useState, useCallback } from 'react';
import axios from 'axios';
import { API, getAuthHeaders } from '../App';
import { toast } from 'sonner';

/**
 * Hook to handle calling customers via mobile bridge or fallback to tel: link
 */
export const useCallCustomer = () => {
  const [isCalling, setIsCalling] = useState(false);

  const callCustomer = useCallback(async (phone, customerName) => {
    setIsCalling(true);
    
    try {
      // First, check if mobile device is connected
      const statusResponse = await axios.get(`${API}/mobile/connection-status`, {
        headers: getAuthHeaders()
      });
      
      if (statusResponse.data.connected) {
        // Mobile is connected - send dial command via bridge
        const dialResponse = await axios.post(
          `${API}/mobile/dial`,
          null,
          {
            params: { phone, customer_name: customerName },
            headers: getAuthHeaders()
          }
        );
        
        if (dialResponse.data.success) {
          toast.success(`📞 Calling ${customerName} on your mobile device...`);
        } else {
          throw new Error('Failed to send dial command');
        }
      } else {
        // No mobile connected - show instruction toast
        toast.info(
          `📱 No mobile device connected. Open your phone's browser and go to this site's /mobile page to pair.`,
          { duration: 5000 }
        );
        
        // Still open tel: link as fallback for desktop apps like Skype
        window.location.href = `tel:${phone}`;
      }
    } catch (error) {
      console.error('Call error:', error);
      
      // If API fails, fallback to tel: link
      if (error.response?.status === 404) {
        // No paired device
        toast.info(
          `📱 Pair your mobile first! Click "Pair Mobile Device" in the sidebar.`,
          { duration: 5000 }
        );
      } else {
        toast.error('Failed to initiate call. Try again.');
      }
      
      // Fallback to tel: link
      window.location.href = `tel:${phone}`;
    } finally {
      setIsCalling(false);
    }
  }, []);

  return { callCustomer, isCalling };
};
